import { iPromotionTier } from "@/interfaces/promotions";
import { PromotionModel } from "@/models";
import { PromotionPolicy } from "@/policies";
import { auth } from "@/services";

(function (angular) {
  "use strict";

  angular.module("app").directive("promotion", promotion);

  promotion.$inject = [
    "Promotions",
    "PromotionsTellMeMoreApi",
    "$rootScope",
    "modalService",
    "$uibModal",
    "handleError",
    "thisSiteSettings",
  ];

  function promotion(
    Promotions,
    PromotionsTellMeMoreApi,
    $rootScope,
    modalService,
    $uibModal,
    handleError,
    thisSiteSettings,
  ) {
    function promotionLink($scope, el, attr) {
      // Set scope defaults

      // properties
      $scope.thisSiteSettings = thisSiteSettings;
      $scope.permissionChecks = {
        canManage: PromotionPolicy.canManage(
          auth.user(),
          new PromotionModel($scope.promotion),
        ),
      };
      $scope.PromotionModel = PromotionModel;
      $scope.thisUser = $rootScope.thisUser;

      // methods
      $scope.tellMeMore = tellMeMore;
      $scope.editPromotion = editPromotion;
      $scope.classnames = {
        "promotion--bronze": $scope.promotion.tier === iPromotionTier.bronze,
        "promotion--silver": $scope.promotion.tier === iPromotionTier.silver,
        "promotion--gold": $scope.promotion.tier === iPromotionTier.gold,
        "promotion--platinum":
          $scope.promotion.tier === iPromotionTier.platinum,
      };

      /**
       * Call the Tell Me More API end point to email a promotion owner
       */
      function tellMeMore() {
        PromotionsTellMeMoreApi.post(
          {
            id: $scope.promotion.id,
          },
          function handleTellMeMoreResponse() {
            $scope.promotion.told = true;
            $scope.promotion.told_status = "";

            modalService.open({
              templateUrl: "modals/promotion-claimed.html",
              controller: [
                "$scope",
                "$uibModalInstance",
                function ($scope, $uibModalInstance) {
                  $scope.dismiss = $uibModalInstance.dismiss;
                },
              ],
              windowClass: "promotion-claimed",
            });
          },
          function handleTellMeMoreError() {
            $scope.promotion.told = false;
            $scope.promotion.told_status =
              "there was an issue claiming promotion, please try again";
          },
        );
      }

      /**
       * Edits the news via a modal, and updates model
       * @param  {int} newsId - ID of news to edit
       * @return {void}
       */
      function editPromotion(promotionId) {
        Promotions.managePromotion(promotionId).result.then(
          function (updatedPromo) {
            $scope.onEdit(updatedPromo);
          },
          function (err) {
            handleError(err);
          },
        );
      }
    }

    return {
      transclude: true,
      restrict: "E",
      templateUrl: "directives/promotion.html",
      link: promotionLink,
      scope: {
        promotion: "=", // (required) {object} promotion object
        hideClaimButton: "=?",
        onEdit: "=?", // {function} parent scope update function
      },
    };
  }
})(angular);
